import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MuiListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';

const styles = theme => ({
  root: {},
  white: {
    color: theme.palette.common.white,
  },
  primaryGray: {
    color: theme.palette.facet.primaryGray,
  },
});

const ListItemText = ({
  className,
  classes,
  resource,
  selected,
}) => {
  const meetingType = resource.selectedOptionPrompt('meetingType');
  const meetingTime = moment(resource.attr('startTime')).format('lll');
  const meetingIsCancelled = resource.attr('isCancelled') === 'true';
  const clientWasNoShow = resource.attr('clientNoShow') === 'true';
  const clientCancelled = resource.attr('clientCancelled') === 'true';
  const meetingIsReschedule = resource.attr('isRescheduled') === 'true';

  let meetingLabel = '';
  if (clientCancelled) {
    meetingLabel = ' - CLIENT CANCELLED';
  } else if (clientWasNoShow) {
    meetingLabel = ' - CLIENT NO SHOW';
  } else if (meetingIsCancelled) {
    meetingLabel = ' - CANCELLED';
  } else if (meetingIsReschedule) {
    meetingLabel = ' - RESCHEDULED';
  }

  return (
    <MuiListItemText
      className={classNames(classes.root, className)}
      primary={meetingTime}
      primaryTypographyProps={{
        noWrap: true,
        variant: 'h6',
      }}
      secondary={
        <div>
          <div>{meetingType.concat(meetingLabel)}</div>
          <div>{resource.attr('title')}</div>
        </div>
      }
      secondaryTypographyProps={{
        noWrap: true,
        variant: 'body1',
      }}
      classes={{
        primary: (selected) ? classes.white : classes.primaryGray,
        secondary: (selected) ? classes.white : classes.primaryGray,
      }}
    />
  );
};

ListItemText.defaultProps = {
  className: '',
};

ListItemText.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ListItemText);
